//import playerStore from "./player_store";
import { loadScript } from "./ajax";
import { addDocEvent } from "lib/player_util";
//import { matchPath } from "react-router";

export default class Onload {
  constructor() {
    // this.debug_page_events();
    this.polyfillMatches();
    // this.setup_once();
    // this.mark_non_turbolinks();
    this.setup_fb();

    // reload if app version mismatch
    this.addDOMLoadEvent(() => {
      if (_jm.body_ver) {
        _jango.check_client_ver(_jm.body_ver);
      }
    });

    // ping GA with ad= param
    this.addWindowLoadEvent(() => {
      console.log("window.load: ping GA if ad=");
      if (_jm?.se_ad){ // && typeof window.ga == "function") {
       // ReactGA.event({ category: _jm.se_ad });
        window.gtag("event", _jm.se_ad)
        //window.ga("send", "event", _jm.se_ad);
      }
    });
  }

  // debug_page_events = () => {
  //   $(document).on(
  //     "turbolinks:click \
  // turbolinks:before-visit \
  // turbolinks:visit \
  // turbolinks:request-start \
  // turbolinks:request-end \
  // turbolinks:before-cache \
  // turbolinks:before-render \
  // turbolinks:render \
  // turbolinks:load",
  //     function (e) {
  //       console.log("turbo event", e.type, document.URL, e);
  //     }
  //   );
  // };

  polyfillMatches() {
    if (Element && !Element.prototype.matches) {
      var proto = Element.prototype;
      proto.matches =
        proto.matchesSelector ||
        proto.mozMatchesSelector ||
        proto.msMatchesSelector ||
        proto.oMatchesSelector ||
        proto.webkitMatchesSelector;
    }
  }

  addDOMLoadEvent(callback) {
    document.addEventListener("DOMContentLoaded", callback, false);
  }

  addWindowLoadEvent(callback) {
    window.addEventListener("load", callback, false);
  }

  // refreshCSRFTokens() {
  //   const token = document
  //     .querySelector('meta[name="csrf-token"]')
  //     ?.getAttribute("content");

  //   if (token) {
  //     document
  //       .querySelectorAll('input[name="authenticity_token"]')
  //       .forEach((input) => {
  //         return (input.value = token);
  //       });
  //   }
  // }

  // setup_once() {
  // make "turbo?" work after splash
  // addDocEvent("turbolinks:request-start", (e) => {
  //   console.log(e);
  //   var xhr = e.data.xhr;
  //   xhr.setRequestHeader("X-XHR-Referer", "jango.com");
  // });

  //  addDocEvent("turbolinks:load", (_e) => {
  //$.rails.refreshCSRFTokens();

  //   this.refreshCSRFTokens();

  // try {
  //   if (playerStore.user_id != _jm.user_id) {
  //     console.log("trigger user_id:change");

  //     let event;
  //     if (typeof Event === "function") {
  //       event = new Event("user_id:change");
  //     } else {
  //       //IE11
  //       event = document.createEvent("Event");
  //       event.initEvent("user_id:change", true, true);
  //     }

  //     document.dispatchEvent(event);

  //     //  $(document).trigger("user_id:change");
  //   }
  // } catch (e) {
  //   console.log("trigger user_id:change:", e);
  // }

  // scan anbd attach on every turbo page?

  // $(function () {
  //   $("[rel=lightbox]").magnificPopup({
  //     type: "image",
  //     zoom: {
  //       enabled: true,
  //     },
  //     retina: {
  //       ratio: 1, // Increase this number to enable retina image support.
  //       // Image in popup will be scaled down by this number.
  //       // Option can also be a function which should return a number (in case you support multiple ratios). For example:
  //       // ratio: function() { return window.devicePixelRatio === 1.5 ? 1.5 : 2  }

  //       replaceSrc: function (item, ratio) {
  //         return item.src.replace("_lg", "_xl");
  //       }, // function that changes image source
  //     },
  //   });
  // });
  // });

  // https://github.com/turbolinks/turbolinks/issues/272
  // https://thelucid.com/2019/02/20/handling-get-remote-forms-with-turbolinks-in-rails-6

  // addDocEvent(
  //   "ajax:beforeSend",
  //   "form[method=get][data-remote=true]",
  //   (event) => {
  //     const detail = event.detail,
  //       _xhr = detail[0],
  //       options = detail[1];

  //     Turbolinks.visit(options.url);
  //     event.preventDefault();
  //   }
  // );

  // addDocEvent("click", ".alertable-overlay", () => {
  //   console.log(".alertable-overlay CLICKED");
  //   $(".alertable-ok").click();

  //   $(".alertable, .alertable-overlay").remove();
  // });

  // addDocEvent("click", "[rel=lightbox]", (event) => {
  //   event.preventDefault();

  //   const href = event.currentTarget.href;

  //   $.magnificPopup.open({
  //     items: {
  //       src:
  //         href.indexOf("radioairplay.com") > 0
  //           ? href.replace("_lg", "")
  //           : href.replace("_lg", "_xl"),
  //     },
  //     type: "image",
  //     // zoom: {
  //     //   enabled: true,
  //     // },
  //     retina: {
  //       ratio: 1, // Increase this number to enable retina image support. 1 disables
  //       // Image in popup will be scaled down by this number.
  //       // Option can also be a function which should return a number (in case you support multiple ratios). For example:
  //       // ratio: function() { return window.devicePixelRatio === 1.5 ? 1.5 : 2  }

  //       replaceSrc: function (item, _ratio) {
  //         return item.src.indexOf("radioairplay.com") > 0
  //           ? item.src.replace("_lg", "")
  //           : item.src.replace("_lg", "_xl");
  //       }, // function that changes image source
  //     },
  //   });
  // });

  // pageview in miscs/ga on landing
  // "virtual" hit on render - turbolinks:load fires on landing
  // addDocEvent("turbolinks:render", () => {
  //   //    console.log("turbolinks:render window.ga:", window.ga);
  //   if (typeof window.ga == "function") {
  //     window.ga("send", "pageview", window.location.pathname, {
  //       dimension2: "virtual",
  //       hitCallback: () => {
  //         console.log("ga hit: virtual", window.location.pathname);
  //       },
  //     });
  //   }
  // });

  // addDocEvent("user_id:change", () => {
  //   console.log("user_id:change:" + _jm.user_id);
  //   playerStore.set_user_id(_jm.user_id);
  //   playerStore.merge({ station_id: _jm.station_id });
  // });

  // addDocEvent("click", "a[data-more-videos]", (event) => {
  //   var data = $.parseJSON($(this).attr("data-more-videos"));
  //   $(this).hide();
  //   window._jango.more_videos(data.target, data.song_id, data.artist_id);
  //   event.stopPropagation();
  //   return false;
  // });

  // addDocEvent("click", ".general_lyrics_link", () => {
  //   window.ga("send", "event", "link", "click", "lyrics");
  // });

  // addDocEvent("click", "#lyrics_string", () => {
  //   window.ga("send", "event", "link", "click", "lyrics");
  // });

  // addDocEvent("click", "#lyrics_string", () => {
  //   window.ga("send", "event", "player", "click", "lyrics");
  // });

  // turbograft/turbolinks class event to prevent jquery memory leak
  // included in newer turbolinks?
  // $(document).on("page:after-node-removed", function (event) {
  //   $(event.data).remove();
  // });

  //made'em -- airplay thumbs up
  // addDocEvent("submit", "#lo-comment-on-artist", function () {
  //   if (typeof _jm.user_id == "undefined" || !parseInt(_jm.user_id)) {
  //     try {
  //       $("#lo-comment-on-artist").disable();
  //     } catch (e) {
  //       console.log(e);
  //     }
  //     popme();
  //     return false;
  //   }
  //   if (
  //     $("#lo-comment").val().length < 1 ||
  //     $("#lo-comment").val().match(/^\s+$/)
  //   ) {
  //     alert("Please enter some text to post a comment.");
  //     return false;
  //   }
  // });

  // //made'em -- airplay thumbs up
  // addDocEvent("submit", "#bfemail", function () {
  //   if (
  //     $("#bfemail").val().length < 6 ||
  //     $("#bfemail").val().match(/^\s+$/)
  //   ) {
  //     alert("Please enter a valid email address.");
  //     return false;
  //   }
  // });

  // //band artist profile page
  // addDocEvent("submit", "#comment-on-artist", function () {
  //   if (
  //     $("#comment").val().length < 1 ||
  //     $("#comment").val().match(/^\s+$/)
  //   ) {
  //     alert("Please enter some text to post a comment.");
  //     return false;
  //   }
  // });

  // $(document).on("page:change", function() {
  //   $(function() {
  //     var at_el = $("#artist_twitter[data-twandle]");
  //     if (at_el[0] && at_el.is(":empty")) {
  //       window._jango.load_tweet(at_el.data("twandle"));
  //     }
  //   });
  // });

  // try {
  //   document.documentElement.setAttribute("data-useragent", navigator.userAgent);
  // } catch (e) {}
  // }

  //   mark_non_turbolinks() {
  //     addDocEvent("turbolinks:load", () => {
  //       console.log("mark_non_turbolinks");
  //       document
  //         .querySelectorAll(
  //           "a[target=player], a[data-method=post][data-remote=true]"
  //         )
  //         .forEach((el) => {
  // //          console.log("mark", el);
  //           el.setAttribute("data-turbolinks", false);
  //         });
  //     });
  //   }
  /*
        const el = $("a[href*='/music/']");
        el.filter(function () {
          // match artist profile page only
          // remove any video links or song links like /music/artist/song only /music/artist+name
          return this.href.match(/\/music\/(\+|%|\d|\w)+[^\/]$/i);
        })
          .attr("data-turbolinks", false)
          .attr("data-partial", "artist_profile");

        el.filter(function () {
          // match songs page only
          const matched = matchPath(this.href, {
            path: "/music/:artist/:song/video",
            exact: true,
            strict: false,
          });
          console.log("matched mark songs link", matched);
          return matched;
          // return this.href.match(/\/music\/(\+|%|\d|\w)+[^\/]$/i);
        })
          .attr("data-turbolinks", false)
          .attr("data-partial", "song_show");
          */
  //   });
  // });

  setup_fb() {
    console.log("FB: setup_fb");
    const FBInit = () => {
      console.log("FB: FB.init");
      FB.init({
        appId: _jm.fb_app_id,
        version: _jm.fb_api_version,
        status: true,
        cookie: true,
        xfbml: true,
        frictionlessRequests: true,
      });
      //  $("#perm").append($("#fb-root").detach());
    };
    window.fbAsyncInit = FBInit;

    this.addDOMLoadEvent(() => {
      loadScript(`https://connect.facebook.net/${_jm.locale_lookup}/sdk.js`);
    });

    addDocEvent("modal:load", (event) => {
      if (typeof FB !== "undefined" && FB !== null) {
        console.log("FB: FB.XFBML.parse, event.type:", event.type);
        FB.XFBML.parse();
      }
    });

    // $(document).on("turbolinks:before-cache", function () {
    //   $("[data-turbolinks-no-cache]").remove();
    // });
  }

  // setup_fb() {
  //   window.fb_events_bound = false;
  //   window.fb_root = null;

  //   window.bindFacebookEvents = function () {
  //     $(document)
  //       .on("turbolinks:load", window.saveFacebookRoot)
  //       .on("turbolinks:load modal:load", (e) => {
  //         window.restoreFacebookRoot();
  //         return typeof window.FB !== "undefined" && window.FB !== null
  //           ? window.FB.XFBML.parse()
  //           : void 0;
  //       });
  //     return (window.fb_events_bound = true);
  //   };

  //   window.saveFacebookRoot = function () {
  //     return (window.fb_root = $("#fb-root").detach());
  //   };

  //   window.restoreFacebookRoot = function () {
  //     if ($("#fb-root").length > 0) {
  //       return $("#fb-root").replaceWith(window.fb_root);
  //     }
  //     return $("body").append(window.fb_root);
  //   };

  //   window.loadFacebookSDK = function () {
  //     window.fbAsyncInit = window.initializeFacebookSDK;
  //     return $.getScript(`//connect.facebook.net/${_jm.locale_lookup}/sdk.js`);
  //   };

  //   window.initializeFacebookSDK = function () {
  //     return window.FB.init({
  //       appId: _jm.fb_app_id,
  //       version: _jm.fb_api_version,
  //       status: true,
  //       cookie: true,
  //       xfbml: true,
  //       frictionlessRequests: true,
  //     });
  //   };

  //   $(() => {
  //     window.loadFacebookSDK();
  //     if (!window.fb_events_bound) {
  //       return window.bindFacebookEvents();
  //     }
  //   });
  // }
}
